// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-charges-page .pricing_page {
  /*  font-family: Poppins; */
}

/* Ensure consistent box-sizing */
*,
*::before,
*::after {
  box-sizing: border-box;
}

.service-charges-page .choose_the_plan {
  position: relative;
  /* font-family: Poppins; */
  font-weight: 600;
  font-size: 28px;
  color: #070862;
  text-align: center;
}
.service-charges-page .choose_the_plan span {
  font-size: 20px;
  font-weight: 400;
}

.service-charges-page .service_content.jsx-3215938339 span.jsx-3215938339 {
  display: block;
  /* font-family: Poppins; */
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: #000;
}

.service-charges-page label {
  display: block;
  margin-bottom: 5px;
}

.service-charges-page .cards_placeholder {
  background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);
  max-height: 830px;
  margin-bottom: 80rem;
  /* width: 1375.8px; */
}

.service-charges-page .automated-main-container .sub-desc {
  /* font-family: "Poppins"; */
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 30px;
  color: #4f4f4f;
}

.service-charges-page input[type="range"] {
  width: 100%;
}

.service-charges-page .checkbox-label {
  display: flex;
  margin-left: 5px;
  margin-top: 3px;
}

.service-charges-page .button-container {
  display: contents;
  align-items: "left";
}

.service-charges-page button {
  background-color: #1c2464;
  color: #fff;
  border: none;
  padding: 10px;
  margin: 1px;
  border-radius: 5px;
  cursor: pointer;
}

.service-charges-page h1 {
  text-align: center;
  font-weight: 600;
}

.service-charges-page .input-container {
  margin-bottom: 60px;
}

.service-charges-page .label-text {
  font-size: 20px;
}

.service-charges-page .input-field input {
  border: none;
  background: none;
  outline: none;
}

/* participant-card */

.service-charges-page .cal-body-earnings {
  /* font-family: Poppins; */
  color: #fff;
  display: flex;
  padding: 20px;
  height: 650px;
  max-width: 650px;
}

.service-charges-page h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

.service-charges-page .earnings-item {
  display: flex;
  align-items: center;
  margin-bottom: 70px;
}

.service-charges-page .earnings-icon {
  margin-top: 16px;
  font-size: 24px;
  margin-right: 10px;
}

.service-charges-page .earnings-icon1 {
  font-size: 24px;
  margin-right: 10px;
  margin-top: 53px;
}

.service-charges-page .earnings-label1 {
  margin-top: 20px;
  flex-grow: 1;
  font-weight: 600;
  font-size: 20px;
}
.service-charges-page .earnings-label2 {
  margin-top: 50px;
  flex-grow: 1;
  font-weight: 600;
  font-size: 20px;
}

.service-charges-page .earnings-label {
  flex-grow: 1;
  font-weight: 600;
  font-size: 20px;
}

.service-charges-page .earnings-value {
  font-weight: 600;
  color: #333;
  font-size: 19px;
}

.service-charges-page .earnings-value1 {
  margin-top: 53px;
  font-weight: 600;
  color: #333;
  font-size: 19px;
}

.service-charges-page .earnings-total {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 70px !important;
  padding-top: 10px;
  border-top: 2px solid #ccc;
}

.service-charges-page .earnings-fee {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.service-charges-page .earnings-estimated {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-top: 10px;
  border-top: 2px solid #ccc;
}

.service-charges-page .earnings-note {
  font-size: 12px;
  color: #666;
  text-align: center;
  margin-top: 20px;
}

.service-charges-page .calculator-notes {
  margin-top: 50px;
  margin-left: 170px;
  /* font-family: "Poppins"; */
  font-weight: 400;
  font-size: 14px;
  color: #636363;
  text-align: left;
  line-height: 15px;
}

.service-charges-page .earnings-container {
  border: 1px solid rgb(225, 190, 190);
}

.service-charges-page .calculator,
.service-charges-page .earnings-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 25px;
  /*   font-family: Poppins; */
  width: calc(
    50% - 40px
  ); /* Calculate width for each card, considering margin */
  max-width: 450px; /* Adjust maximum width as needed */
  /* height: 550px; */
}

.service-charges-page .calculator {
  background-color: #000639;
  color: white;
}

.service-charges-page .cal-body {
  display: flex;
  justify-content: center;
}

.service-charges-page .calculator h1,
.service-charges-page .earnings-container h1 {
  font-size: 22px;
  margin-bottom: 20px;
  text-align: center;
}

.service-charges-page .input-container {
  margin-bottom: 40px; /* Reduce margin between input containers */
}

.service-charges-page .divider-line-cal {
  border: 1px solid #5c6aca;
  margin-bottom: 35px; /* Reduce margin between divider and content */
}

.service-charges-page .checkbox-container {
  margin-bottom: 10px; /* Reduce margin between checkbox and content */
}

.service-charges-page .pre_booking1.jsx-3215938339 {
  margin-top: 62px;
  /*  font-family: Poppins; */
  font-size: 20px;
  color: #000;
  display: block;
  margin-bottom: 44px;
}

.table.jsx-3215938339 {
  display: flex;
  padding: 0px 20px;
  margin-bottom: 12px;
  /*   font-family: Poppins; */
}

.table-column.jsx-3215938339 {
  margin-bottom: 1em;
  width: 100%;
  /*   font-family: Poppins; */
}

.table-row.jsx-3215938339 {
  border: 1px#adadad solid;
  height: 3em;
  margin: auto;
  width: 100%;
  /* font-family: Poppins; */
}

.border-radius-one.jsx-3215938339 {
  border-top-left-radius: 8px;
}

.border-radius-two.jsx-3215938339 {
  border-bottom-left-radius: 8px;
}

.border-radius-three.jsx-3215938339 {
  border-top-right-radius: 8px;
}

.border-radius-four.jsx-3215938339 {
  border-bottom-right-radius: 8px;
}

.price-table.jsx-3215938339 {
  margin: 15px 0;
  width: 90%;
}

.table-header.jsx-3215938339 {
  background: #5c6aca;
  /*  font-family: Poppins; */
  font-size: 12px;
  font-weight: 400;
  line-height: 27px;
  color: #fff;
  padding: 15px;
}

.table-content.jsx-3215938339 {
  /*   font-family: Poppins; */
  font-size: 14px;
  font-weight: 400;
  line-height: 27px;
  color: #10060d;
  background: #fff;
}

.service-charges-page button {
  background-color: #1c2464;
  color: #fff;
  border: none;
  margin-top: 20px;
  border-radius: 5px;
  cursor: pointer;
}

.service-charges-page button:hover {
  background-color: #5c6aca;
}

/* card */
.service-charges-page .container {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: auto;
}

/* Adjusted height for the three cards */
.service-charges-page .card {
  flex: 1 1;
  max-width: calc(33.33% - 8px); /* Adjust according to your spacing */
  height: 350px;
  background-color: #fff;
  border-radius: 8px;
  margin-right: 20px; /* Adjust margin between cards if needed */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.service-charges-page .card.jsx-3215938339:hover {
  outline: solid 3px#394071;
}

.service-charges-page button.outline-btn {
  border: 1px solid #000639;
  background: scroll;
  color: #000639;
  border-radius: 5px;
  font-size: 14px;
  font-weight: 500;
  padding: 10px 30px;
  transition: 0.2s all;
}
/* .service-charges-page button.outline-btn1 {
  border: 1px solid #000639;
  background: scroll;
  color: #000639;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 30px;
  transition: 0.2s all;
  margin-top: -50px;
} */

.service-charges-page button.outline-btn:hover {
  border: 1px solid #000639;
  background: #000639;
  color: #feffff;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 30px;
}

.service-charges-page .tick_style.jsx-3215938339 {
  width: 15px;
  margin-top: -2px;
}

.service-charges-page .free_event.jsx-3215938339 {
  padding: 0 45px 0 0 0;
  background: #ffffff;
  border-radius: 14px 14px 14px 14px;
}

.service-charges-page .hosted_event.jsx-3215938339 {
  padding: 0 0 30px 0;
  background: #ffffff;
  border-radius: 14px 14px 14px 14px;
}

.service-charges-page .percentage.jsx-3215938339 {
  font-weight: 700;
  font-size: 50px;
  /*   font-family: Poppins; */
}

.service-charges-page .service_type {
  /*   font-family: Poppins; */
  font-weight: 700;
  font-size: 22px;
  color: #ffffff;
  display: block;
  background-color: #5c6aca;
  padding: 20px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  /* min-height: 85px; */
}

.service-charges-page .service_type-cal {
  /*  font-family: Poppins; */
  font-weight: 700;
  font-size: 32px;
  color: #ffffff;
  display: block;
  padding: 20px;
  min-height: 85px;
}

.service-charges-page .percent_value.jsx-3215938339 {
  padding: 16px 0;
  /*  font-family: Poppins; */
  font-weight: 500;
  font-size: 60px;
  line-height: 90px;
  color: #000;
  display: block;
}

.service-charges-page .percent_value1 {
  padding: 16px 0px;
  /* font-family: Poppins; */
  font-weight: 500;
  font-size: 20px;
  line-height: 40px;
  color: #000;
  display: block;
  margin-top: 59px;
}

.service-charges-page .pre_booking.jsx-3215938339 {
  margin-top: 12px;
  /*  font-family: Poppins; */
  font-size: 20px;
  color: #000;
  display: block;
}

.service-charges-page .addition_info.jsx-3215938339 {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);
  display: block;
}

.service-charges-page .red-conditions.jsx-3215938339 {
  /*   font-family: Poppins; */
  font-size: 12px !important;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  padding: 1.5rem;
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: auto;
  display: block !important;
}

.service-charges-page .conditions.jsx-3215938339 {
  /*   font-family: Nunito; */
  font-size: 12px !important;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  padding: 1.5rem;
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: auto;
  display: block !important;
}

.service-charges-page .debit-amount.jsx-3215938339 {
  padding: 13px;
  background: #f6f7ff;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.service-charges-page .debit_amount {
  /*   font-family: Poppins; */
  font-weight: 600;
  font-size: 18px;
  line-height: 1.5;
  color: #5c6aca;
}

.service-charges-page .card_amount {
  /*  font-family: Poppins; */
  font-weight: 500;
  font-size: 16px;
  color: #070862;
  text-align: right;
}

.service-charges-page .conditions.jsx-3215938339 {
  /*   font-family: Poppins; */
  font-size: 12px !important;
  font-weight: 500;
  line-height: 18px;
  text-align: left;
  padding: 1.5rem;
  color: rgba(0, 0, 0, 0.5) !important;
  margin-top: auto;
  display: block !important;
}

.service-charges-page .percentage_num {
  /*  font-family: Poppins; */
  font-weight: 600;
  font-size: 14px;
  line-height: 1.43;
  color: #070862;
  display: block;
  padding: 0 5px 0 0;
}

.service-charges-page .amount {
  /*   font-family: Poppins; */
  font-weight: 600;
  font-size: 14px;
  line-height: 1.43;
  color: #070862;
}

.service-charges-page .conditions_bold {
  /*   font-family: Poppins; */
  font-weight: 600;
  font-size: 16px;
  line-height: 1.43;
  color: #070862;
  padding: 0 10px 0 0;
}

.service-charges-page .conditions-italic.jsx-3215938339 {
  /*   font-family: Poppins; */
  font-style: italic;
  font-size: 14px;
  line-height: 1.43;
  color: rgba(0, 0, 0, 0.5);
  padding: 0 5px 0 0;
}

.service-charges-page .right_arrow {
  /*   font-family: Poppins; */
  font-weight: 600;
  font-size: 14px;
  line-height: 1.43;
  color: #5c6aca;
  display: flex;
  align-items: center;
  padding: 10px 0 0 0;
}

.service-charges-page .settlements-text-div.jsx-3215938339 {
  /* background: rgba(246,249,252,1);
  padding: 30px; */
}

.service-charges-page .container-settlement {
  max-width: 800px;
  margin-top: -50px;
  text-align: center;
  /*   font-family: Poppins; */
  padding: 25px;
}

.service-charges-page .settlement-heading {
  font-weight: 600;
}

.service-charges-page .content-settlement {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.service-charges-page .img-settlement {
  width: 100px; /* or whatever size you want */
  height: auto;
  padding: 20px;
  margin-bottom: 10px;
  margin-top: 60px;
}

.service-charges-page h1,
h2 {
  margin-bottom: 10px; /* adjust as needed */
}

.service-charges-page .settlement-sub-text {
  color: #454f5b;
  align-self: stretch;

  width: 100%;
  font: 400 20px/28px Poppins;
}

.service-charges-page .cost-container {
  background: #f4f6f8;
  z-index: 500;
  background-position: right 150px top 220px;
  background-repeat: no-repeat;
}

.service-charges-page .cost-container .awards-title {
  color: #000000;
  font-weight: 600;
  font-size: 20px;
  /*   font-family: "Poppins"; */
  margin-top: -60px;
}

.service-charges-page .cost-container .awards-sub-title {
  /*   font-family: "Poppins"; */
  font-weight: 400;
  font-size: 20px;
  color: #636363;
  text-align: center;
}

.service-charges-page .input-box {
  border-radius: 5px;
  font-size: 18px;
}

.service-charges-page .price-value-text {
  /*   font-family: Poppins; */
  font-weight: 500;
  font-size: 18px;
  line-height: 140%;
  color: #000639;
  border: none;
  max-width: 100px;
}

.service-charges-page input[type="number"] {
  font-size: 18px;
}

/* feature list*/

.service-charges-page .feature-heading {
  position: relative;
  /*  font-family: Poppins; */
  font-weight: 600;
  font-size: 22px;
  color: #070862;
  text-align: center;
  /*margin-top: -90px;*/
}
.service-charges-page .service_content {
  /*display: flex;*/
  flex-direction: column;
  align-items: center;
  width: 85%;
}

.service-charges-page .feature-card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* width: 100%; */
  background-color: #ffffff;
  border-radius: 8px;
  /*padding: 20px;
  margin-top: -60px;*/
}

.service-charges-page .feature-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
  font-size: 20px;
}

.service-charges-page .feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.service-charges-page .tick_style {
  width: 20px;
  height: 20px;
}

.gstPercent {
  width: 35%;
  height: 80%;
  margin-left: 5px;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .service-charges-page .feature-card {
    flex-direction: column;
    align-items: center;
  }
  .service-charges-page .feature-list {
    width: 100%;
    align-items: flex-start;
  }
}

@media (max-width: 768px) {
  .service-charges-page .container {
    flex-direction: column;
  }

  .service-charges-page .card,
  .service-charges-page .hosted_event.jsx-3215938339 {
    max-width: 100%;
    height: auto;
    margin-right: 0;
    margin-bottom: 20px;
  }

  .service-charges-page .card-body {
    padding: 15px;
  }

  .service-charges-page .card-footer,
  .service-charges-page .hosted_event.jsx-3215938339 .card-footer {
    padding: 15px;
  }

  .service-charges-page .price-table {
    width: 100%;
  }

  .service-charges-page .table {
    flex-direction: column;
    padding: 0;
  }

  .service-charges-page .table-row,
  .service-charges-page .table-header,
  .service-charges-page .table-content {
    width: 100%;
  }

  .service-charges-page .settlements-text-div {
    padding: 20px;
  }

  .service-charges-page .container-settlement {
    max-width: 100%;
    padding: 20px;
  }

  .service-charges-page .img-settlement {
    width: 80px;
    padding: 15px;
  }

  .service-charges-page .settlement-sub-text {
    width: 100%;
    font-size: 14px;
  }

  .service-charges-page button {
    width: 100%;
    padding: 10px;
  }

  .service-charges-page input[type="range"] {
    width: 100%;
  }

  .service-charges-page .checkbox-container {
    margin-bottom: 15px;
  }

  .service-charges-page .cards_placeholder {
    background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);
    max-height: 2040px;
    margin-bottom: 145rem;
    /* width: 1375.8px; */
  }

  .service-charges-page .calculator {
    background-color: #000639;
    color: white;
    height: 575px;
  }

  .service-charges-page .cost-container .awards-title {
    color: #000000;
    font-weight: 610;
    font-size: 20px;
    /*     font-family: "Poppins"; */
    margin-top: -30px;
  }

  .service-charges-page .cost-container .awards-sub-title {
    /* font-family: "Poppins"; */
    font-weight: 400;
    font-size: 18px;
    color: #636363;
    text-align: left;
    margin-bottom: 20px;
  }

  .gstPercent {
    width: 35%;
    height: 60%;
    margin-left: 3px;
  }

  .service-charges-page .checkbox-label {
    display: flex;
    margin-left: 5px;
    margin-top: 3px;
  }

  .service-charges-page .calculator-notes {
    margin-top: 50px;
    margin-left: 170px;
    /* font-family: "Poppins"; */
    font-weight: 400;
    font-size: 14px;
    color: #636363;
    text-align: left;
    line-height: 20px;
  }
}

@media (max-width: 768px) {
  .service-charges-page .cal-body {
    display: block;
    justify-content: start;
  }
  .service-charges-page .calculator,
  .service-charges-page .earnings-container {
    width: 100%;
    max-width: 760px;
    margin-bottom: 20px; /* Add margin between the cards */
    height: 525px;
  }

  .service-charges-page .cal-body-earnings {
    flex-direction: row;
    padding: 100px;
  }

  .service-charges-page .earnings-item,
  .service-charges-page .earnings-total,
  .service-charges-page .earnings-fee,
  .service-charges-page .earnings-estimated {
    flex-direction: row;
    align-items: start;
  }

  .service-charges-page .calculator-notes {
    margin-left: 10px;
    text-align: left;
  }

  .service-charges-page .price-table {
    width: 100%;
  }

  .service-charges-page .table {
    flex-direction: column;
    padding: 0;
  }

  .service-charges-page .table-row,
  .service-charges-page .table-header,
  .service-charges-page .table-content {
    width: 100%;
  }

  .service-charges-page .feature-heading {
    position: relative;
    /*  font-family: Poppins; */
    font-weight: 600;
    font-size: 20px;
    color: #070862;
    text-align: center;
    margin-top: 0px;
  }

  .service-charges-page .feature-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* width: 100%; */
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    margin-top: 0px;
  }
}

/* Standard CSS for all browsers */
/* .service-charges-page .cards_placeholder {
  background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .service-charges-page .cards_placeholder {
    max-height: 210px;
    margin-bottom: 100rem;
  }
} */

.container {
  min-height: 150px !important;
}
@media (max-width: 768px) {
  .service-charges-page .img-settlement {
    margin-top: 35px;
  }

  .service-charges-page .cards_placeholder {
    max-height: 2000px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/pricingCalculator.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oEAAoE;EACpE,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA,qBAAqB;;AAErB;EACE,0BAA0B;EAC1B,WAAW;EACX,aAAa;EACb,aAAa;EACb,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B;;GAEC,EAAE,sDAAsD;EACzD,gBAAgB,EAAE,mCAAmC;EACrD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;EAEE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,yBAAyB;EACzB,mBAAmB,EAAE,8CAA8C;AACrE;;AAEA;EACE,mBAAmB,EAAE,+CAA+C;AACtE;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAKE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EAGE,2BAA2B;AAC7B;;AAEA;EAGE,8BAA8B;AAChC;;AAEA;EAGE,4BAA4B;AAC9B;;AAEA;EAGE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,SAAO;EACP,6BAA6B,EAAE,qCAAqC;EACpE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB,EAAE,0CAA0C;EAC9D,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;;;;;;;;;;GAUG;;AAEH;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oCAAoC;EACpC,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;kBACgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB,EAAE,qBAAqB;AAC5C;;AAEA;EACE,cAAc;EACd,mBAAmB;;EAEnB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,0CAA0C;EAC1C,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,gBAAgB;;AAEhB;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB;qBACmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,eAAe;IACf,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oEAAoE;IACpE,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,gCAAgC;IAChC,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;EACxB;EACA;;IAEE,WAAW;IACX,gBAAgB;IAChB,mBAAmB,EAAE,iCAAiC;IACtD,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;;;IAIE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;;;;;;;;;GASG;;AAEH;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".service-charges-page .pricing_page {\n  /*  font-family: Poppins; */\n}\n\n/* Ensure consistent box-sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n.service-charges-page .choose_the_plan {\n  position: relative;\n  /* font-family: Poppins; */\n  font-weight: 600;\n  font-size: 28px;\n  color: #070862;\n  text-align: center;\n}\n.service-charges-page .choose_the_plan span {\n  font-size: 20px;\n  font-weight: 400;\n}\n\n.service-charges-page .service_content.jsx-3215938339 span.jsx-3215938339 {\n  display: block;\n  /* font-family: Poppins; */\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 18px;\n  color: #000;\n}\n\n.service-charges-page label {\n  display: block;\n  margin-bottom: 5px;\n}\n\n.service-charges-page .cards_placeholder {\n  background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);\n  max-height: 830px;\n  margin-bottom: 80rem;\n  /* width: 1375.8px; */\n}\n\n.service-charges-page .automated-main-container .sub-desc {\n  /* font-family: \"Poppins\"; */\n  font-style: normal;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 30px;\n  color: #4f4f4f;\n}\n\n.service-charges-page input[type=\"range\"] {\n  width: 100%;\n}\n\n.service-charges-page .checkbox-label {\n  display: flex;\n  margin-left: 5px;\n  margin-top: 3px;\n}\n\n.service-charges-page .button-container {\n  display: contents;\n  align-items: \"left\";\n}\n\n.service-charges-page button {\n  background-color: #1c2464;\n  color: #fff;\n  border: none;\n  padding: 10px;\n  margin: 1px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.service-charges-page h1 {\n  text-align: center;\n  font-weight: 600;\n}\n\n.service-charges-page .input-container {\n  margin-bottom: 60px;\n}\n\n.service-charges-page .label-text {\n  font-size: 20px;\n}\n\n.service-charges-page .input-field input {\n  border: none;\n  background: none;\n  outline: none;\n}\n\n/* participant-card */\n\n.service-charges-page .cal-body-earnings {\n  /* font-family: Poppins; */\n  color: #fff;\n  display: flex;\n  padding: 20px;\n  height: 650px;\n  max-width: 650px;\n}\n\n.service-charges-page h1 {\n  font-size: 24px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.service-charges-page .earnings-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 70px;\n}\n\n.service-charges-page .earnings-icon {\n  margin-top: 16px;\n  font-size: 24px;\n  margin-right: 10px;\n}\n\n.service-charges-page .earnings-icon1 {\n  font-size: 24px;\n  margin-right: 10px;\n  margin-top: 53px;\n}\n\n.service-charges-page .earnings-label1 {\n  margin-top: 20px;\n  flex-grow: 1;\n  font-weight: 600;\n  font-size: 20px;\n}\n.service-charges-page .earnings-label2 {\n  margin-top: 50px;\n  flex-grow: 1;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.service-charges-page .earnings-label {\n  flex-grow: 1;\n  font-weight: 600;\n  font-size: 20px;\n}\n\n.service-charges-page .earnings-value {\n  font-weight: 600;\n  color: #333;\n  font-size: 19px;\n}\n\n.service-charges-page .earnings-value1 {\n  margin-top: 53px;\n  font-weight: 600;\n  color: #333;\n  font-size: 19px;\n}\n\n.service-charges-page .earnings-total {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  margin-top: 70px !important;\n  padding-top: 10px;\n  border-top: 2px solid #ccc;\n}\n\n.service-charges-page .earnings-fee {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.service-charges-page .earnings-estimated {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n  padding-top: 10px;\n  border-top: 2px solid #ccc;\n}\n\n.service-charges-page .earnings-note {\n  font-size: 12px;\n  color: #666;\n  text-align: center;\n  margin-top: 20px;\n}\n\n.service-charges-page .calculator-notes {\n  margin-top: 50px;\n  margin-left: 170px;\n  /* font-family: \"Poppins\"; */\n  font-weight: 400;\n  font-size: 14px;\n  color: #636363;\n  text-align: left;\n  line-height: 15px;\n}\n\n.service-charges-page .earnings-container {\n  border: 1px solid rgb(225, 190, 190);\n}\n\n.service-charges-page .calculator,\n.service-charges-page .earnings-container {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 25px;\n  /*   font-family: Poppins; */\n  width: calc(\n    50% - 40px\n  ); /* Calculate width for each card, considering margin */\n  max-width: 450px; /* Adjust maximum width as needed */\n  /* height: 550px; */\n}\n\n.service-charges-page .calculator {\n  background-color: #000639;\n  color: white;\n}\n\n.service-charges-page .cal-body {\n  display: flex;\n  justify-content: center;\n}\n\n.service-charges-page .calculator h1,\n.service-charges-page .earnings-container h1 {\n  font-size: 22px;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.service-charges-page .input-container {\n  margin-bottom: 40px; /* Reduce margin between input containers */\n}\n\n.service-charges-page .divider-line-cal {\n  border: 1px solid #5c6aca;\n  margin-bottom: 35px; /* Reduce margin between divider and content */\n}\n\n.service-charges-page .checkbox-container {\n  margin-bottom: 10px; /* Reduce margin between checkbox and content */\n}\n\n.service-charges-page .pre_booking1.jsx-3215938339 {\n  margin-top: 62px;\n  /*  font-family: Poppins; */\n  font-size: 20px;\n  color: #000;\n  display: block;\n  margin-bottom: 44px;\n}\n\n.table.jsx-3215938339 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0px 20px;\n  margin-bottom: 12px;\n  /*   font-family: Poppins; */\n}\n\n.table-column.jsx-3215938339 {\n  margin-bottom: 1em;\n  width: 100%;\n  /*   font-family: Poppins; */\n}\n\n.table-row.jsx-3215938339 {\n  border: 1px#adadad solid;\n  height: 3em;\n  margin: auto;\n  width: 100%;\n  /* font-family: Poppins; */\n}\n\n.border-radius-one.jsx-3215938339 {\n  -webkit-border-top-left-radius: 8px;\n  -moz-border-radius-topleft: 8px;\n  border-top-left-radius: 8px;\n}\n\n.border-radius-two.jsx-3215938339 {\n  -webkit-border-bottom-left-radius: 8px;\n  -moz-border-radius-bottomleft: 8px;\n  border-bottom-left-radius: 8px;\n}\n\n.border-radius-three.jsx-3215938339 {\n  -webkit-border-top-right-radius: 8px;\n  -moz-border-radius-topright: 8px;\n  border-top-right-radius: 8px;\n}\n\n.border-radius-four.jsx-3215938339 {\n  -webkit-border-bottom-right-radius: 8px;\n  -moz-border-radius-bottomright: 8px;\n  border-bottom-right-radius: 8px;\n}\n\n.price-table.jsx-3215938339 {\n  margin: 15px 0;\n  width: 90%;\n}\n\n.table-header.jsx-3215938339 {\n  background: #5c6aca;\n  /*  font-family: Poppins; */\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 27px;\n  color: #fff;\n  padding: 15px;\n}\n\n.table-content.jsx-3215938339 {\n  /*   font-family: Poppins; */\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 27px;\n  color: #10060d;\n  background: #fff;\n}\n\n.service-charges-page button {\n  background-color: #1c2464;\n  color: #fff;\n  border: none;\n  margin-top: 20px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.service-charges-page button:hover {\n  background-color: #5c6aca;\n}\n\n/* card */\n.service-charges-page .container {\n  display: flex;\n  justify-content: space-between;\n  max-width: 1200px;\n  margin: auto;\n}\n\n/* Adjusted height for the three cards */\n.service-charges-page .card {\n  flex: 1;\n  max-width: calc(33.33% - 8px); /* Adjust according to your spacing */\n  height: 350px;\n  background-color: #fff;\n  border-radius: 8px;\n  margin-right: 20px; /* Adjust margin between cards if needed */\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.service-charges-page .card.jsx-3215938339:hover {\n  outline: solid 3px#394071;\n}\n\n.service-charges-page button.outline-btn {\n  border: 1px solid #000639;\n  background: scroll;\n  color: #000639;\n  border-radius: 5px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 10px 30px;\n  transition: 0.2s all;\n}\n/* .service-charges-page button.outline-btn1 {\n  border: 1px solid #000639;\n  background: scroll;\n  color: #000639;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 30px;\n  transition: 0.2s all;\n  margin-top: -50px;\n} */\n\n.service-charges-page button.outline-btn:hover {\n  border: 1px solid #000639;\n  background: #000639;\n  color: #feffff;\n  border-radius: 5px;\n  font-size: 15px;\n  font-weight: 500;\n  padding: 10px 30px;\n}\n\n.service-charges-page .tick_style.jsx-3215938339 {\n  width: 15px;\n  margin-top: -2px;\n}\n\n.service-charges-page .free_event.jsx-3215938339 {\n  padding: 0 45px 0 0 0;\n  background: #ffffff;\n  border-radius: 14px 14px 14px 14px;\n}\n\n.service-charges-page .hosted_event.jsx-3215938339 {\n  padding: 0 0 30px 0;\n  background: #ffffff;\n  border-radius: 14px 14px 14px 14px;\n}\n\n.service-charges-page .percentage.jsx-3215938339 {\n  font-weight: 700;\n  font-size: 50px;\n  /*   font-family: Poppins; */\n}\n\n.service-charges-page .service_type {\n  /*   font-family: Poppins; */\n  font-weight: 700;\n  font-size: 22px;\n  color: #ffffff;\n  display: block;\n  background-color: #5c6aca;\n  padding: 20px;\n  border-top-left-radius: 6px;\n  border-top-right-radius: 6px;\n  /* min-height: 85px; */\n}\n\n.service-charges-page .service_type-cal {\n  /*  font-family: Poppins; */\n  font-weight: 700;\n  font-size: 32px;\n  color: #ffffff;\n  display: block;\n  padding: 20px;\n  min-height: 85px;\n}\n\n.service-charges-page .percent_value.jsx-3215938339 {\n  padding: 16px 0;\n  /*  font-family: Poppins; */\n  font-weight: 500;\n  font-size: 60px;\n  line-height: 90px;\n  color: #000;\n  display: block;\n}\n\n.service-charges-page .percent_value1 {\n  padding: 16px 0px;\n  /* font-family: Poppins; */\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 40px;\n  color: #000;\n  display: block;\n  margin-top: 59px;\n}\n\n.service-charges-page .pre_booking.jsx-3215938339 {\n  margin-top: 12px;\n  /*  font-family: Poppins; */\n  font-size: 20px;\n  color: #000;\n  display: block;\n}\n\n.service-charges-page .addition_info.jsx-3215938339 {\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.5);\n  display: block;\n}\n\n.service-charges-page .red-conditions.jsx-3215938339 {\n  /*   font-family: Poppins; */\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: left;\n  padding: 1.5rem;\n  color: rgba(0, 0, 0, 0.5) !important;\n  margin-top: auto;\n  display: block !important;\n}\n\n.service-charges-page .conditions.jsx-3215938339 {\n  /*   font-family: Nunito; */\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: left;\n  padding: 1.5rem;\n  color: rgba(0, 0, 0, 0.5) !important;\n  margin-top: auto;\n  display: block !important;\n}\n\n.service-charges-page .debit-amount.jsx-3215938339 {\n  padding: 13px;\n  background: #f6f7ff;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.service-charges-page .debit_amount {\n  /*   font-family: Poppins; */\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.5;\n  color: #5c6aca;\n}\n\n.service-charges-page .card_amount {\n  /*  font-family: Poppins; */\n  font-weight: 500;\n  font-size: 16px;\n  color: #070862;\n  text-align: right;\n}\n\n.service-charges-page .conditions.jsx-3215938339 {\n  /*   font-family: Poppins; */\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 18px;\n  text-align: left;\n  padding: 1.5rem;\n  color: rgba(0, 0, 0, 0.5) !important;\n  margin-top: auto;\n  display: block !important;\n}\n\n.service-charges-page .percentage_num {\n  /*  font-family: Poppins; */\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.43;\n  color: #070862;\n  display: block;\n  padding: 0 5px 0 0;\n}\n\n.service-charges-page .amount {\n  /*   font-family: Poppins; */\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.43;\n  color: #070862;\n}\n\n.service-charges-page .conditions_bold {\n  /*   font-family: Poppins; */\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.43;\n  color: #070862;\n  padding: 0 10px 0 0;\n}\n\n.service-charges-page .conditions-italic.jsx-3215938339 {\n  /*   font-family: Poppins; */\n  font-style: italic;\n  font-size: 14px;\n  line-height: 1.43;\n  color: rgba(0, 0, 0, 0.5);\n  padding: 0 5px 0 0;\n}\n\n.service-charges-page .right_arrow {\n  /*   font-family: Poppins; */\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.43;\n  color: #5c6aca;\n  display: flex;\n  align-items: center;\n  padding: 10px 0 0 0;\n}\n\n.service-charges-page .settlements-text-div.jsx-3215938339 {\n  /* background: rgba(246,249,252,1);\n  padding: 30px; */\n}\n\n.service-charges-page .container-settlement {\n  max-width: 800px;\n  margin-top: -50px;\n  text-align: center;\n  /*   font-family: Poppins; */\n  padding: 25px;\n}\n\n.service-charges-page .settlement-heading {\n  font-weight: 600;\n}\n\n.service-charges-page .content-settlement {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.service-charges-page .img-settlement {\n  width: 100px; /* or whatever size you want */\n  height: auto;\n  padding: 20px;\n  margin-bottom: 10px;\n  margin-top: 60px;\n}\n\n.service-charges-page h1,\nh2 {\n  margin-bottom: 10px; /* adjust as needed */\n}\n\n.service-charges-page .settlement-sub-text {\n  color: #454f5b;\n  align-self: stretch;\n\n  width: 100%;\n  font: 400 20px/28px Poppins;\n}\n\n.service-charges-page .cost-container {\n  background: #f4f6f8;\n  z-index: 500;\n  background-position: right 150px top 220px;\n  background-repeat: no-repeat;\n}\n\n.service-charges-page .cost-container .awards-title {\n  color: #000000;\n  font-weight: 600;\n  font-size: 20px;\n  /*   font-family: \"Poppins\"; */\n  margin-top: -60px;\n}\n\n.service-charges-page .cost-container .awards-sub-title {\n  /*   font-family: \"Poppins\"; */\n  font-weight: 400;\n  font-size: 20px;\n  color: #636363;\n  text-align: center;\n}\n\n.service-charges-page .input-box {\n  border-radius: 5px;\n  font-size: 18px;\n}\n\n.service-charges-page .price-value-text {\n  /*   font-family: Poppins; */\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 140%;\n  color: #000639;\n  border: none;\n  max-width: 100px;\n}\n\n.service-charges-page input[type=\"number\"] {\n  font-size: 18px;\n}\n\n/* feature list*/\n\n.service-charges-page .feature-heading {\n  position: relative;\n  /*  font-family: Poppins; */\n  font-weight: 600;\n  font-size: 22px;\n  color: #070862;\n  text-align: center;\n  /*margin-top: -90px;*/\n}\n.service-charges-page .service_content {\n  /*display: flex;*/\n  flex-direction: column;\n  align-items: center;\n  width: 85%;\n}\n\n.service-charges-page .feature-card {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  /* width: 100%; */\n  background-color: #ffffff;\n  border-radius: 8px;\n  /*padding: 20px;\n  margin-top: -60px;*/\n}\n\n.service-charges-page .feature-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  font-size: 20px;\n}\n\n.service-charges-page .feature-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.service-charges-page .tick_style {\n  width: 20px;\n  height: 20px;\n}\n\n.gstPercent {\n  width: 35%;\n  height: 80%;\n  margin-left: 5px;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .service-charges-page .feature-card {\n    flex-direction: column;\n    align-items: center;\n  }\n  .service-charges-page .feature-list {\n    width: 100%;\n    align-items: flex-start;\n  }\n}\n\n@media (max-width: 768px) {\n  .service-charges-page .container {\n    flex-direction: column;\n  }\n\n  .service-charges-page .card,\n  .service-charges-page .hosted_event.jsx-3215938339 {\n    max-width: 100%;\n    height: auto;\n    margin-right: 0;\n    margin-bottom: 20px;\n  }\n\n  .service-charges-page .card-body {\n    padding: 15px;\n  }\n\n  .service-charges-page .card-footer,\n  .service-charges-page .hosted_event.jsx-3215938339 .card-footer {\n    padding: 15px;\n  }\n\n  .service-charges-page .price-table {\n    width: 100%;\n  }\n\n  .service-charges-page .table {\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .service-charges-page .table-row,\n  .service-charges-page .table-header,\n  .service-charges-page .table-content {\n    width: 100%;\n  }\n\n  .service-charges-page .settlements-text-div {\n    padding: 20px;\n  }\n\n  .service-charges-page .container-settlement {\n    max-width: 100%;\n    padding: 20px;\n  }\n\n  .service-charges-page .img-settlement {\n    width: 80px;\n    padding: 15px;\n  }\n\n  .service-charges-page .settlement-sub-text {\n    width: 100%;\n    font-size: 14px;\n  }\n\n  .service-charges-page button {\n    width: 100%;\n    padding: 10px;\n  }\n\n  .service-charges-page input[type=\"range\"] {\n    width: 100%;\n  }\n\n  .service-charges-page .checkbox-container {\n    margin-bottom: 15px;\n  }\n\n  .service-charges-page .cards_placeholder {\n    background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);\n    max-height: 2040px;\n    margin-bottom: 145rem;\n    /* width: 1375.8px; */\n  }\n\n  .service-charges-page .calculator {\n    background-color: #000639;\n    color: white;\n    height: 575px;\n  }\n\n  .service-charges-page .cost-container .awards-title {\n    color: #000000;\n    font-weight: 610;\n    font-size: 20px;\n    /*     font-family: \"Poppins\"; */\n    margin-top: -30px;\n  }\n\n  .service-charges-page .cost-container .awards-sub-title {\n    /* font-family: \"Poppins\"; */\n    font-weight: 400;\n    font-size: 18px;\n    color: #636363;\n    text-align: left;\n    margin-bottom: 20px;\n  }\n\n  .gstPercent {\n    width: 35%;\n    height: 60%;\n    margin-left: 3px;\n  }\n\n  .service-charges-page .checkbox-label {\n    display: flex;\n    margin-left: 5px;\n    margin-top: 3px;\n  }\n\n  .service-charges-page .calculator-notes {\n    margin-top: 50px;\n    margin-left: 170px;\n    /* font-family: \"Poppins\"; */\n    font-weight: 400;\n    font-size: 14px;\n    color: #636363;\n    text-align: left;\n    line-height: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .service-charges-page .cal-body {\n    display: block;\n    justify-content: start;\n  }\n  .service-charges-page .calculator,\n  .service-charges-page .earnings-container {\n    width: 100%;\n    max-width: 760px;\n    margin-bottom: 20px; /* Add margin between the cards */\n    height: 525px;\n  }\n\n  .service-charges-page .cal-body-earnings {\n    flex-direction: row;\n    padding: 100px;\n  }\n\n  .service-charges-page .earnings-item,\n  .service-charges-page .earnings-total,\n  .service-charges-page .earnings-fee,\n  .service-charges-page .earnings-estimated {\n    flex-direction: row;\n    align-items: start;\n  }\n\n  .service-charges-page .calculator-notes {\n    margin-left: 10px;\n    text-align: left;\n  }\n\n  .service-charges-page .price-table {\n    width: 100%;\n  }\n\n  .service-charges-page .table {\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .service-charges-page .table-row,\n  .service-charges-page .table-header,\n  .service-charges-page .table-content {\n    width: 100%;\n  }\n\n  .service-charges-page .feature-heading {\n    position: relative;\n    /*  font-family: Poppins; */\n    font-weight: 600;\n    font-size: 20px;\n    color: #070862;\n    text-align: center;\n    margin-top: 0px;\n  }\n\n  .service-charges-page .feature-card {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    /* width: 100%; */\n    background-color: #ffffff;\n    border-radius: 8px;\n    padding: 20px;\n    margin-top: 0px;\n  }\n}\n\n/* Standard CSS for all browsers */\n/* .service-charges-page .cards_placeholder {\n  background: linear-gradient(180deg, #ffffff -20.12%, #d7dcff 105.6%);\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .service-charges-page .cards_placeholder {\n    max-height: 210px;\n    margin-bottom: 100rem;\n  }\n} */\n\n.container {\n  min-height: 150px !important;\n}\n@media (max-width: 768px) {\n  .service-charges-page .img-settlement {\n    margin-top: 35px;\n  }\n\n  .service-charges-page .cards_placeholder {\n    max-height: 2000px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
